import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "img1 h-auto" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " O limite de adição de NFs liberadas será de até 80 recebimentos por NF; "),
  /*#__PURE__*/_createElementVNode("li", null, "E será aceita uma nota por dia.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useHead } from "@vueuse/head"
import { HomeContainer } from "@/components/atoms"
import Loading from "@/components/molecules/Loading.vue"
import { getPayload } from "../repositories/login"
import { onMounted } from "vue"
import { SAVE_USER_REV } from "../store/mutationsTypes"
import { getUserById } from "../repositories/users"
import { ref } from "vue"
import { useStore } from "../store"

import Home from "../components/organisms/Home.vue"
import { useClient } from "@/clients/AxiosClient"
import { setSendPermission } from "@/utils/permissions"
import { Routes } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'Homepage',
  setup(__props) {

const store = useStore()

let showLoading = ref(false)

useHead({ title: "Comissão Revenda - Home" })

onMounted(async () => {
	const payload = await getPayload()

	const userInfo: any = await getUserById(payload.data.data.payload.id)

	const data = {
		username: userInfo.username,
		codRev: userInfo.codRev,
		aidc: userInfo.aidc,
		rbcode: userInfo.rbcode,
		name: userInfo.user.name,
		email: userInfo.user.email,
		id: userInfo.user.id,
	}

	store.commit(SAVE_USER_REV, data)

	await getSendingPermission(data.codRev)
})

const showNotification = ref(true)
const showBankNotification = ref(true)
const showMaintenanceNotification = ref(true)
const showExpiratonDateNotification = ref(true)

async function getSendingPermission(codRev: string) {
	const resValidation: any = await useClient().get(
		Routes.GET_SEND_PERMISSION + `?codRevSQL=${codRev}`
	)
	setSendPermission(resValidation.data.message.result)
}

const alertTimeout = () => {
	setTimeout(() => {
		showNotification.value = false
	}, 10000)
}

const removeNotification = () => {
	showBankNotification.value = false
}

const removeNotification2 = () => {
	showMaintenanceNotification.value = false
}

const removeNotification3 = () => {
	showExpiratonDateNotification.value = false
}

alertTimeout()

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showLoading))
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(HomeContainer), null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(Home, {
          onEnableLoading: _cache[0] || (_cache[0] = (value) => _isRef(showLoading) //@ts-ignore
 ? showLoading.value = value : showLoading = value)
        })
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_v_alert, {
      class: "notificationBox",
      transition: "slide-x-transition",
      style: {"position":"absolute","right":"1rem","top":"1rem"},
      color: "warning",
      icon: "$warning",
      title: "Prezadas Revendas",
      text: "Devido ao processo de fechamento, o envio de NFs para recebimento de comissões deve acontecer até o dia 27 do mês.\n\t\t\t"
    }, null, 512), [
      [_vShow, showNotification.value]
    ]),
    _withDirectives(_createVNode(_component_v_alert, {
      class: "notificationBox",
      transition: "slide-x-transition",
      style: {"position":"absolute","right":"1rem","top":"8rem"},
      color: "warning",
      icon: "$warning",
      title: "Prezadas Revendas",
      text: "Agradecemos pela sua atenção e colaboração. Caso haja alguma alteração nos dados bancários da sua empresa, solicitamos que nos informe através do formulário de dúvidas. Siga o passo a passo demonstrado no tópico 4 do FAQ, que foi cuidadosamente elaborado para guiar você durante esse processo."
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { class: "buttonContent" }, [
          _createElementVNode("button", {
            class: "button",
            onClick: removeNotification
          }, "Entendi")
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, showBankNotification.value]
    ]),
    _withDirectives(_createVNode(_component_v_alert, {
      class: "notificationBox",
      transition: "slide-x-transition",
      style: {"position":"absolute","right":"1rem","top":"19.5rem"},
      color: "info",
      icon: "$info",
      title: "Prezadas Revendas"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Atenção para a nova otimização de envio de notas fiscais (NFs): "),
        _hoisted_2,
        _createElementVNode("div", { class: "buttonContent" }, [
          _createElementVNode("button", {
            class: "button",
            onClick: removeNotification2
          }, "Entendi")
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, showMaintenanceNotification.value]
    ]),
    _withDirectives(_createVNode(_component_v_alert, {
      class: "notificationBox",
      transition: "slide-x-transition",
      style: {"position":"absolute","right":"1rem","top":"31rem"},
      color: "info",
      icon: "$info",
      title: "Prezadas Revendas"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Informamos que o prazo para resgate de comissões disponíveis é de 02 anos a contar da disponibilidade. "),
        _hoisted_3,
        _createTextVNode(" Após essa data, as comissões não resgatadas expiram e não poderão ser mais recuperadas. "),
        _createElementVNode("div", { class: "buttonContent" }, [
          _createElementVNode("button", {
            class: "button",
            onClick: removeNotification3
          }, "Entendi")
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, showExpiratonDateNotification.value]
    ])
  ], 64))
}
}

})